import { graphql, useMutation } from "react-relay";

import { useNoteRemovePageMutation } from "./__generated__/useNoteRemovePageMutation.graphql";
import { useCallback } from "react";

export function useNoteRemovePage(noteId: string, pageId: string) {
  const [removePage, info] = useMutation<useNoteRemovePageMutation>(graphql`
    mutation useNoteRemovePageMutation($noteId: ID!, $pageId: ID!) {
      note(id: $noteId) {
        page(id: $pageId) {
          remove {
            id
            ...NoteEdit
            pages {
              id
            }
          }
        }
      }
    }
  `);

  const onRemovePage = useCallback(() => {
    removePage({
      variables: {
        noteId,
        pageId,
      },
      optimisticUpdater: (store, data) => {
        const note = store.get(noteId);

        if (note) {
          const pages = note.getLinkedRecords("pages");
          if (!pages) {
            return;
          }

          note.setLinkedRecords(
            pages.filter((page) => page.getDataID() !== pageId),
            "pages"
          );
        }
      },
    });
  }, [noteId, pageId, removePage]);

  return [onRemovePage, info] as const;
}
